export interface CompanyStat { value:string; label:string; }
export interface BusinessCard { number:string; title:string; description:string; image:string; }
export const companyStats: CompanyStat[]=[{value:'50+',label:'Years of Excellence'},{value:'20+',label:'Countries Worldwide'},{value:'30K+',label:'People Across Our Business'},{value:'4.2M',label:'Barrels Equivalent / Day'}];
export const businessCards: BusinessCard[]=[{number:'01',title:'Upstream',description:'Exploring, producing and managing energy resources with operational excellence.',image:'/assets/images/business-upstream.svg'},{number:'02',title:'Downstream',description:'Transforming resources into products that power industries and everyday life.',image:'/assets/images/business-downstream.svg'},{number:'03',title:'New Energy',description:'Investing in technology, efficiency and lower-carbon solutions for tomorrow.',image:'/assets/images/business-new-energy.svg'}];
export const COMPANY_DATA = {
  company: {
    name: 'MAIZE',
    legalName: 'TRADING FZC',
    tagline: 'Sowing Trust. Reaping Success.',
    fullName: 'Maize Trading FZC',
    image: 'assets/images/maize-logo.JPG',
    description:
      'Maize Trading FZC connects energy resources, markets and logistics to deliver reliable solutions for a changing world.',
    location: 'ELOB Office No.E-32F-15, Hamriyah Free Zone Phase 1, Sharjah, United Arab Emirates',
    email: 'info@maizetrading.com',
    phone1: '+971 52 391 8008',
    phone2: '+971 50 799 3517'
  },
  navigation: [
    {
      label: 'Home',
      url: '#top'
    },
    {
      label: 'About Us',
      url: '#about'
    },
    {
      label: 'Products',
      url: '#products'
    },
    {
      label: 'Services',
      url: '#services'
    },
    {
      label: 'Careers',
      url: '#careers'
    },
    {
      label: 'Contact',
      url: '#contact'
    }
  ],
  socialLinks: [
    {
      name: 'LinkedIn',
      icon: 'bi bi-linkedin',
      url: 'https://www.linkedin.com/in/maize-trading-fzc-8b712442b/'
    },
    {
    name: 'Facebook',
    icon: 'bi bi-facebook',
    url: 'https://www.facebook.com/'
  },
      {
    name: 'WhatsApp',
    icon: 'bi bi-whatsapp',
    url: 'https://wa.me/971523918008'
  },
    {
      name: 'Instagram',
      icon: 'bi bi-instagram',
      url: '#'
    }
  ],
  services: {
  eyebrow: 'OUR SERVICES',
  title: 'Reliable Movement.',
  titleHighlight: 'Global Reach.',
  description:
    'We coordinate reliable shipping, sourcing and delivery solutions to move energy products efficiently across international markets.',
  items: [
    {
      id: 1,
      title: 'Global Shipping & Logistics',
      description:
        'Coordinated cargo movement across international routes, with a focus on dependable transportation and efficient shipment execution.',
      image: 'assets/images/services/shipping.jpg'
    },
    {
      id: 2,
      title: 'Reliable Supply & Sourcing',
      description:
        'Dependable sourcing and supply channels built around product requirements, availability and customer needs.',
      image: 'assets/images/services/supply.jpg'
    },
    {
      id: 3,
      title: 'Cargo & Delivery Management',
      description:
        'Coordinated shipment schedules, documentation and delivery to support smooth movement from origin to destination.',
      image: 'assets/images/services/delivery.jpg'
    }
  ]
},
careers: {
  eyebrow: 'CAREERS',
  title: 'Build Your Future.',
  titleHighlight: 'Grow With Us.',
  description:
    'We welcome professionals who are passionate about energy, international trade and building long-term relationships across global markets.',
  email: 'careers@maizetrading.com',
  emailLabel: 'Send Your Resume',
  message:
    'If you are interested in exploring opportunities with Maize Trading FZC, send us your latest resume and our team will get in touch when a suitable opportunity becomes available.'
},



  hero: {
    slides: [
      {
        kicker: 'ENERGY • TRADING • LOGISTICS',
        title: 'Powering Progress.',
        accent: 'Energizing Tomorrow.',
        description:
          'Maize Trading FZC connects energy resources, markets and logistics to deliver dependable solutions for a changing world.',
        buttonText: 'Discover More',
        buttonUrl: '#about',
        image: 'assets/images/hero-image.jpg'
      },
      {
        kicker: 'GLOBAL ENERGY PARTNER',
        title: 'Connecting Markets.',
        accent: 'Creating Value.',
        description:
          'We build trusted trading relationships across energy markets with a focus on reliability, transparency and long-term value.',
        buttonText: 'Our Business',
        buttonUrl: '#business',
        image: 'assets/images/hero-image1.jpg'
      },
      {
        kicker: 'BUILT FOR TOMORROW',
        title: 'Moving Energy.',
        accent: 'Moving Business Forward.',
        description:
          'Our ambition is simple: deliver energy solutions that help businesses and communities move forward.',
        buttonText: 'Learn More',
        buttonUrl: '#about',
        image: 'assets/images/hero-image2.jpg'
      }
    ]
  },
//   statistics: [
//     {
//       value: '25+',
//       label: 'Years of Experience'
//     },
//     {
//       value: '20+',
//       label: 'Countries'
//     },
//     {
//       value: '50+',
//       label: 'Global Partners'
//     },
//     {
//       value: '24/7',
//       label: 'Global Operations'
//     }
//   ],
  about: {
  eyebrow: 'ABOUT MAIZE TRADING',
  title: 'Moving Energy.',
  accent: 'Creating Value.',
  description:
    'Maize Trading FZC is a dynamic energy and commodities trading company focused on connecting reliable sources of supply with markets across the globe.',
  secondaryDescription:
    'Built on strong relationships, market knowledge and a commitment to reliable execution, we work with partners across the energy and trading ecosystem to create long-term value.',
  buttonText: 'Discover Our Story',
  buttonUrl: '#contact',
  image: 'assets/images/about-us.jpg',
  stats: [
    {
      value: '15+',
      label: 'Markets Connected'
    },
    {
      value: '10+',
      label: 'Years of Experience'
    },
    {
      value: '20+',
      label: 'Global Partners'
    },
    {
      value: '24/7',
      label: 'Market Support'
    }
  ],
  approachTitle: 'Our Approach',
  approach: [
    {
      title: 'Reliable',
      description:
        'We focus on dependable supply, transparent communication and consistent execution across every transaction.'
    },
    {
      title: 'Connected',
      description:
        'Our global network connects suppliers, buyers and logistics partners across multiple markets.'
    },
    {
      title: 'Forward Thinking',
      description:
        'We continuously look for smarter ways to respond to changing markets and evolving customer requirements.'
    }
  ]
},
//   about: {
//     sectionLabel: 'WHO WE ARE',
//     title: 'Building Energy Solutions for a Changing World',
//     description:
//       'Maize Trading FZC is an international energy and trading company focused on connecting resources, markets and customers through dependable and efficient solutions.',
//     buttonText: 'Discover Maize Trading',
//     buttonUrl: '#about',
//     image: 'assets/images/about.jpg'
//   },
  products: {
  eyebrow: 'OUR PRODUCTS',
  title: 'Energy Products.',
  accent: 'Global Reach.',
  description:
    'We connect reliable sources of energy, petroleum and petrochemical products with customers across international markets.',
  buttonText: 'Explore Our Products',
  categories: [
    {
      id: 'petroleum',
      title: 'Petroleum Products',
      shortTitle: 'Petroleum',
      description:
        'Reliable petroleum products sourced and supplied to meet diverse commercial and industrial requirements.',
      image: 'assets/images/products-petroleum.jpg',
      products: [
         {
      id: 'base-oil',
      name: 'Base Oil',
      shortDescription:
        'Quality base oils supplied for industrial and manufacturing requirements.',
      description:
        'We connect customers with reliable sources of base oil to support a range of industrial and manufacturing applications.',
      image:
        'assets/images/base-oil.JPG',
      applications: [
        'Lubricant manufacturing',
        'Industrial applications',
        'Manufacturing',
        'Specialised formulations'
      ]
    },
    {
      id: 'bitumen',
      name: 'Bitumen',
      shortDescription:
        'Reliable bitumen supply for infrastructure and industrial applications.',
      description:
        'We facilitate the supply of bitumen products to meet customer requirements across infrastructure, construction and industrial markets.',
      image:
        'assets/images/bitumen.jpg',
      applications: [
        'Road construction',
        'Infrastructure',
        'Waterproofing',
        'Industrial applications'
      ]
    },
    {
      id: 'fuel-oil',
      name: 'Fuel Oil',
      types: [
        'Fuel Oil 180 CST',
        'Fuel Oil 380 CST'
      ],
      shortDescription:
        'Reliable fuel oil supply for industrial, commercial and energy requirements.',
      description:
        'We connect customers with reliable sources of fuel oil to support industrial, commercial, power generation and marine requirements.',
      image:
        'assets/images/fuel-oil.png',
      applications: [
        'Industrial fuel',
        'Power generation',
        'Marine applications',
        'Commercial energy'
      ]
    },
    {
      id: 'rpo',
      name: 'Rubber Process Oil (RPO)',
      shortDescription:
        'Rubber process oils supporting manufacturing and industrial applications.',
      description:
        'We facilitate the supply of Rubber Process Oil for customers across rubber manufacturing and related industrial applications.',
      image:
        'assets/images/base-oil-old.png',
      applications: [
        'Rubber manufacturing',
        'Industrial applications',
        'Manufacturing',
        'Specialised processing'
      ]
    },
    {
      id: 'gasoil',
      name: 'Gas Oil',
      types: [
        'Low Sulfur Gas Oil',
        'High Sulfur Gas Oil'
      ],
      shortDescription:
        'Gasoil products supplied to meet customer and market specifications.',
      description:
        'Our gasoil trading activities connect reliable supply with customers requiring consistent quality and dependable delivery.',
      image:
        'assets/images/gasoil.png',
      applications: [
        'Industrial applications',
        'Transportation',
        'Power generation',
        'Commercial requirements'
      ]
    },
    {
      id: 'white-spirit',
      name: 'White Spirit',
      shortDescription:
        'Reliable white spirit supply for industrial and commercial applications.',
      description:
        'We facilitate the supply of white spirit products for customers across industrial, manufacturing and commercial markets.',
      image:
        'assets/images/kerosene.png',
      applications: [
        'Paint and coatings',
        'Industrial cleaning',
        'Manufacturing',
        'Solvent applications'
      ]
    },
    {
      id: 'mixed-hydrocarbon-oil',
      name: 'Mixed Hydrocarbon Oil',
      shortDescription:
        'Hydrocarbon oil products supplied for diverse industrial and energy requirements.',
      description:
        'We connect customers with reliable sources of mixed hydrocarbon oil according to their specific commercial and industrial requirements.',
      image:
        'assets/images/gasoil.png',
      applications: [
        'Industrial applications',
        'Energy requirements',
        'Manufacturing',
        'Commercial applications'
      ]
    },
    {
      id: 'naphtha',
      name: 'Naphtha',
      shortDescription:
        'Naphtha products supporting refining and petrochemical requirements.',
      description:
        'We facilitate the supply of naphtha products for customers across refining, petrochemical and industrial markets.',
      image:
        'assets/images/naphtha.png',
      applications: [
        'Petrochemical feedstock',
        'Refining',
        'Industrial processing',
        'Chemical production'
      ]
    }
      ]
    },
    {
      id: 'petrochemical',
      title: 'Petrochemical Products',
      shortTitle: 'Petrochemical',
      description:
        'A range of petrochemical products serving industrial, manufacturing and commercial markets.',
      image:
        'assets/images/products-petrochemical.jpg',
      products: [
        {
          id: 'aromatics',
          name: 'Aromatics',
          shortDescription:
            'Aromatics products supporting a wide range of chemical and industrial applications.',
          description:
            'We support the supply of aromatics products for customers across chemical, manufacturing and industrial markets.',
          image:
            'assets/images/aromatics.png',
          applications: [
            'Chemical production',
            'Industrial manufacturing',
            'Petrochemical processing',
            'Specialised applications'
          ]
        },
        {
          id: 'methanol',
          name: 'Methanol',
          shortDescription:
            'Methanol solutions for industrial and chemical applications.',
          description:
            'Our methanol trading activities connect international supply with customers across a range of industrial and chemical applications.',
          image:
            'assets/images/methanol.png',
          applications: [
            'Chemical production',
            'Industrial applications',
            'Manufacturing',
            'Energy applications'
          ]
        },
        {
          id: 'glycols',
          name: 'Glycols',
          shortDescription:
            'Glycol products serving diverse industrial and manufacturing requirements.',
          description:
            'We facilitate the supply of glycol products for customers operating across manufacturing and industrial sectors.',
          image:
            'assets/images/glycols.png',
          applications: [
            'Manufacturing',
            'Chemical processing',
            'Industrial applications',
            'Specialised formulations'
          ]
        },
        {
          id: 'solvents',
          name: 'Solvents',
          shortDescription:
            'Industrial solvent solutions supplied according to customer requirements.',
          description:
            'Our solvent portfolio supports customers across industrial, manufacturing and chemical applications.',
          image:
            'assets/images/solvents.png',
          applications: [
            'Chemical manufacturing',
            'Industrial processing',
            'Manufacturing',
            'Specialised applications'
          ]
        }
      ]
    }
  ],
  values: [
    {
      number: '01',
      title: 'Reliable Supply',
      description:
        'We focus on dependable sourcing and consistent supply to support our customers.'
    },
    {
      number: '02',
      title: 'Market Knowledge',
      description:
        'Our understanding of international markets helps us identify opportunities and deliver effective trading solutions.'
    },
    {
      number: '03',
      title: 'Trusted Partnerships',
      description:
        'We believe long-term relationships are the foundation of sustainable business success.'
    }
  ],
  contactTitle: 'Looking for a reliable trading partner?',
  contactDescription:
    'Talk to our team about your product requirements and market opportunities.',
  contactButton:
    'Contact Our Team'
},
  business: {
    sectionLabel: 'OUR BUSINESS',
    title: 'Connecting Energy Across Markets',
    description:
      'Our activities span energy trading, logistics and global market solutions.',
    services: [
      {
        title: 'Energy Trading',
        description:
          'Connecting producers, suppliers and customers across international energy markets.',
        image: 'assets/images/business-energy.jpg',
        url: '#business'
      },
      {
        title: 'Oil & Gas',
        description:
          'Supporting the movement and supply of essential oil and gas products.',
        image: 'assets/images/business-oil.jpg',
        url: '#business'
      },
      {
        title: 'Logistics',
        description:
          'Reliable logistics and supply-chain solutions connecting markets efficiently.',
        image: 'assets/images/business-logistics.jpg',
        url: '#business'
      }
    ]
  },
  globalPresence: {
    sectionLabel: 'GLOBAL PRESENCE',
    title: 'Connected Across the World',
    description:
      'Our network connects markets, partners and customers across key regions around the globe.',
    countries: [
      'United Arab Emirates',
      'India',
      'Saudi Arabia',
      'Oman',
      'Singapore',
      'United Kingdom'
    ]
  },
  sustainability: {
    sectionLabel: 'SUSTAINABILITY',
    title: 'Creating Value for Today and Tomorrow',
    description:
      'We believe responsible business and long-term growth go hand in hand. Our approach focuses on people, operational responsibility and sustainable growth.',
    buttonText: 'Our Sustainability Approach',
    buttonUrl: '#sustainability',
    image: 'assets/images/sustainability.jpg'
  },
  news: {
    sectionLabel: 'LATEST NEWS',
    title: 'News & Insights',
    articles: [
      {
        date: '01 JAN 2026',
        title: 'Maize Trading FZC expands global trading capabilities',
        description:
          'Our latest developments and activities across international energy markets.',
        image: 'assets/images/news-1.jpg',
        url: '#news'
      },
      {
        date: '15 FEB 2026',
        title: 'Building stronger relationships across global markets',
        description:
          'Strengthening partnerships and creating long-term value for our customers.',
        image: 'assets/images/news-2.jpg',
        url: '#news'
      },
      {
        date: '20 MAR 2026',
        title: 'Our approach to responsible growth',
        description:
          'Discover how responsible business remains central to our long-term strategy.',
        image: 'assets/images/news-3.jpg',
        url: '#news'
      }
    ]
  },
  // careers: {
  //   sectionLabel: 'CAREERS',
  //   title: 'Build Your Future With Us',
  //   description:
  //     'Join a growing international team working across energy, trading and logistics.',
  //   buttonText: 'Explore Careers',
  //   buttonUrl: '#careers',
  //   image: 'assets/images/careers.jpg'
  // },
  footer: {
    columns: [
      {
        title: 'Company',
        links: [
          {
            label: 'About Us',
            url: '#about'
          },
          {
            label: 'Products',
            url: '#products'
          },
          {
            label: 'Services',
            url: '#services'
          },
          {
            label: 'Careers',
            url: '#careers'
          }
        ]
      },
      {
        title: 'Business',
        links: [
          {
            label: 'Energy Trading',
            url: '#business'
          },
          {
            label: 'Oil & Gas',
            url: '#business'
          },
          {
            label: 'Logistics',
            url: '#business'
          },
          {
            label: 'Global Markets',
            url: '#business'
          }
        ]
      }
    ]
  }
};
